import React from 'react';
import { DialogTrigger } from '@adobe/react-spectrum';
import { ActionButton } from '@react-spectrum/button';
import { PublishDialog } from 'app/views/components/dialogs/publish/PublishDialog';
import { useOnline } from 'app/views/hooks/useOnline';
import { DisabledActionButton } from '../../core/DisabledTooltip';
export const PublishButton = () => {
    const isOnline = useOnline();
    if (!isOnline) {
        return (React.createElement(DisabledActionButton, { label: "Publish", tooltip: "Publishing is not available when working offline" }));
    }
    return (React.createElement(DialogTrigger, null,
        React.createElement(ActionButton, { "data-test-id": "header-publish", isQuiet: true }, "Publish"),
        React.createElement(PublishDialog, null)));
};
